import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster } from 'react-hot-toast';
export default function ToasterProvider() {
    return _jsx(Toaster, {});
}
